
import React, { useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Row } from 'react-bootstrap';

import { getFormValues } from '../../../lib/utils';

import FormModal from '../../../components/FormModal';
import { useFocusableRef } from '../../../components/form/useFocusableRef';

import {
  createOrganisationToken,
  fetchOrganisationTokens,
} from '../actions';

const confirmButtonProps = {
  variant: 'success',
};

const addText = "Add API token";
const formDescriptionText = "token_description";

function AddOrganisationTokenFormModal({
  organisationId,
  createOrganisationToken,
  fetchOrganisationTokens,
  children,
  ...props
}) {

  const [description, setDescription] = useState('');
  const [pristineDescription, setPristineDescription] = useState(true);
  const [valid, setValid] = useState(false);

  const formRef = useRef(null);
  const [descriptionRef, setShown] = useFocusableRef(null);

  const handleSubmit = useCallback(async e => {
    const { token_description } = getFormValues(e, formRef.current) || {};
    try {
      await createOrganisationToken({ id: organisationId }, token_description);
      await fetchOrganisationTokens({ id: organisationId });
    }
    catch(err) {
      // allow error to prevent closing of the modal
      throw new Error(err);
    }
  }, [formRef.current, organisationId]);

  return (
    <FormModal
      // set defaults
      header={addText}
      confirmText={addText}
      confirmButtonProps={confirmButtonProps}
      // add given props
      {...props}
      // override given props
      size="md"
      valid={valid}
      onShow={useCallback(() => {
        setShown(true);
      }, [])}
      onClose={useCallback(() => {
        setShown(false);
        setDescription('');
      }, [])}
      form={(
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Form.Group as={Row} controlId={formDescriptionText}>
            <Form.Label column sm={5}>
              Token Description
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                ref={descriptionRef}
                type="text"
                name={formDescriptionText}
                isInvalid={!pristineDescription && !valid}
                value={description}
                onChange={useCallback(e => {
                  const desc = e.target.value;
                  setPristineDescription(false);
                  setDescription(desc);
                  setValid(!!desc);
                }, [])}
              />
            </Col>
          </Form.Group>
        </Form>
      )}
    >
      {children}
    </FormModal>
  );
}

const mapDispatchToProps = {
  createOrganisationToken,
  fetchOrganisationTokens,
};

export default connect(null, mapDispatchToProps)(AddOrganisationTokenFormModal);
